import React from 'react'

import ChangePassword from './ChangePassword'
import Logout from '../business/Logout'
import Dashboard from './Dashboard'
import Dashboard2 from './Dashboard2'
import TyanLims from './TyanLims'
import { SysSettings, DptPsnMng, ServiceManagement, SysHolidayManagement, MailList, JobManagement, SignOffPositionManagement, CurrencyManagement, ExchangeRateManagement, AccountOpenManagement } from './SysManage'
import { AttendanceRecord, AbnormalAttendance, ForgetSwipeCardApplyQuiry, ForgetSwipeCardApply, ForgetSwipeCardApproval } from './AttendanceManagement'
import { OverTimeQuiry, OverTimeApply, OverTimeApproval } from './OvertimeManagement'
import { LeaveInQuiry, LeaveApplication, ReceivingConfirmation, LeaveApproval, DriverConfirmation, LeaveCancellationApplication, LeaveCancellationApproval, TravelReportUpload, WorkTimeManagement } from './LeaveManagement'
import {
	SalaryAdjustmentQuery, SalaryAdjustmentApplication, SalaryAdjustmentApproval, MonthlySalaryQuery,
	MonthlySalaryProduction, MonthlySalaryApproval, ConfirmationDeductionItems, DeductionItemsQuery, BonusInQuiry, BonusApplication, BonusApproval,
	DeductionProcessing
} from './SalaryManagement'
import { OrderingStatistics } from './OrderingStatistics'
import { HolidayManagement, JudgeStandardApplication, AmountEntry, JudgeStandardPreReview, JudgeStandardNewModify, JudgeStandardReview, AmountApprove, JudgeStandardApplyQuery, } from './LaboratoryManagement'
import { AnnouncementManagement } from './AnnouncementManagement'
import { GiveVacationManagement, HolidayBalanceQuery } from './GiveVacationManagement'
import { ProcessManagement, PersonnelFormManagement, ITFormManagement, SealManagement, OthersFormManagement } from './OAManagement'

import { SupplierManagerPage, EvaluateItemManager, NewSupplierApplication, NewSupplierEndorsement, SearchNewSupplier, SearchSupplierEdit, SupplierEditApplication, SupplierEditEndorsement } from './SupplierManagerPage'
import { MaterialManagement } from './MaterialManagement'
import { ConsumableCategoryMagement } from './ConsumableCategoryMagement'
import { EvaluationApplication, ReturnApplication, AuditEvaluation, OpinionFilling, EvaluationQuery } from './SupplierManagerPage/EvaluationManagement'

import { RequisitionApplication, RequisitionEndorsement, RequisitionBargaining, RequisitionQuery } from './RequisitionManageMent'
import {
	ItemsToBePurchased, PurchaseApplication, PurchaseEndorsement, PurchaseQuery, PurchaseToBeAccepted, PurchaseAccepted, ApplicantToBeAccepted, ApplicantAccepted, ConsumablesToBeWarehoused,
	AssetsToBeAccepted, AssetAcceptanceApplication, AssetAcceptanceSignature, EquipmentInformationEntry, AssetAcceptanceQuery
} from './PurchaseManageMent'

import { AdvanceApplication, AdvanceEndorsement, AdvanceAmountPayment, AdvanceQuery, ExpenseApplication, ExpenseEndorsement, ExpenseAmountPayment, ExpenseQuery } from './AdvanceExpenseManageMent'
import { AssetChangeApplication, AssetChangeEndorsement, AssetChange, AssetChangeQuery } from './AssetTransactionManagement'
import { BatchSpecialLeaveQuiry, BatchSpecialLeaveApply, BatchSpecialLeaveApproval } from './BatchSpecialLeaveManagement'
//品质管理
import { MethodApplication, MethodApprove, MethodVerification, MethodVerificationComfirm, DirectorVerificationComfirm, MethodApplyQuery } from './QualityManagement'
// 选择图标 => https://fontawesome.com/cheatsheet?from=io

export default {
	主页: { _icon: "home", _path: "/Dashboard2", _component: Dashboard2, _public: true, },
	// 人事主页: { _icon: "home", _path: "/Dashboard", _component: Dashboard, _public: true, },
	// Lims主页: { _icon: "home", _path: "/TyanLims/UCAuthMain", _component: TyanLims },
	通讯录: { _icon: "address-book", _path: "/MailList", _component: MailList, },
	人事管理: {
		_icon: "users",
		员工基本资料: { _icon: "user", _path: "/DptPsnMng", _component: DptPsnMng, },
		查询: {
			_icon: "search",
			忘刷卡申请查询: { _icon: "search", _path: "/ForgetSwipeCardApplyQuiry", _component: ForgetSwipeCardApplyQuiry, },
			加班查询: { _icon: "search", _path: "/OverTimeQuiry", _component: OverTimeQuiry, },
			假勤查询: { _icon: "search", _path: "/HolidayBalanceQuery", _component: HolidayBalanceQuery, },
			请假查询: { _icon: "user", _path: "/LeaveInQuiry", _component: LeaveInQuiry, },
			销假查询: { _icon: "search", _path: "/LeaveCancellationApplication", _component: LeaveCancellationApplication, },
		},
		考勤管理: {
			_icon: "sign-in",
			异常管理: {
				_icon: "sign-in",
				考勤记录: { _icon: "files-o", _path: "/AttendanceRecord", _component: AttendanceRecord, },
				异常考勤: { _icon: "file-text-o", _path: "/AbnormalAttendance", _component: AbnormalAttendance, },
				忘刷卡申请: { _icon: "pencil-square-o", _path: "/ForgetSwipeCardApply", _component: ForgetSwipeCardApply, },
				忘刷卡签核: { _icon: "check-circle", _path: "/ForgetSwipeCardApproval", _component: ForgetSwipeCardApproval, },
			},
			加班管理: {
				_icon: "clock-o",
				加班申请: { _icon: "pencil-square-o", _path: "/OverTimeApply", _component: OverTimeApply, },
				加班签核: { _icon: "check-circle", _path: "/OverTimeApproval", _component: OverTimeApproval, },
			},
			批量特休假管理: {
				_icon: "clock-o",
				批量特休假查询: { _icon: "search", _path: "/BatchSpecialLeaveQuiry", _component: BatchSpecialLeaveQuiry, },
				批量特休假申请: { _icon: "pencil-square-o", _path: "/BatchSpecialLeaveApply", _component: BatchSpecialLeaveApply, },
				批量特休假签核: { _icon: "check-circle", _path: "/BatchSpecialLeaveApproval", _component: BatchSpecialLeaveApproval, },
			},
			请假管理: {
				_icon: "briefcase",
				假期管理: { _icon: "calendar", _path: "/HolidayManagement", _component: HolidayManagement },
				给假管理: { _icon: "calendar-plus-o", _path: "/GiveVacationManagement", _component: GiveVacationManagement, },
				请假申请: { _icon: "pencil-square-o", _path: "/LeaveApplication", _component: LeaveApplication, },
				代理人签核: { _icon: "check-square-o", _path: "/ReceivingConfirmation", _component: ReceivingConfirmation, },
				请假签核: { _icon: "check-circle", _path: "/LeaveApproval", _component: LeaveApproval, },
				出差报告上传: { _icon: "upload", _path: "/TravelReportUpload", _component: TravelReportUpload, },
				司机确认: { _icon: "check-square-o", _path: "/DriverConfirmation", _component: DriverConfirmation, },
				销假签核: { _icon: "check-circle", _path: "/LeaveCancellationApproval", _component: LeaveCancellationApproval, },
			},
			班别管理: { _icon: "calendar", _path: "/WorkTimeManagement", _component: WorkTimeManagement },
		},
		薪资管理: {
			_icon: "money",
			调薪查询: { _icon: "search", _path: "/SalaryAdjustmentQuery", _component: SalaryAdjustmentQuery, },
			调薪申请: { _icon: "pencil-square-o", _path: "/SalaryAdjustmentApplication", _component: SalaryAdjustmentApplication, },
			调薪签核: { _icon: "check-circle", _path: "/SalaryAdjustmentApproval", _component: SalaryAdjustmentApproval, },
			月薪查询: { _icon: "search", _path: "/MonthlySalaryQuery", _component: MonthlySalaryQuery, },
			月薪制作: { _icon: "pencil-square-o", _path: "/MonthlySalaryProduction", _component: MonthlySalaryProduction, },
			月薪签核: { _icon: "check-circle", _path: "/MonthlySalaryApproval", _component: MonthlySalaryApproval, },
			加扣项查询: { _icon: "check-square-o", _path: "/DeductionItemsQuery", _component: DeductionItemsQuery, },
			加扣项确认: { _icon: "check-square-o", _path: "/ConfirmationDeductionItems", _component: ConfirmationDeductionItems, },
			加扣项处理: { _icon: "check-square-o", _path: "/DeductionProcessing", _component: DeductionProcessing, },
			奖金查询: { _icon: "search", _path: "/BonusInQuiry", _component: BonusInQuiry, },
			奖金申请: { _icon: "pencil-square-o", _path: "/BonusApplication", _component: BonusApplication, },
			奖金签核: { _icon: "check-circle", _path: "/BonusApproval", _component: BonusApproval, },
		},
		公告管理: { _icon: "calendar", _path: "/AnnouncementManagement", _component: AnnouncementManagement },
		订餐统计: { _icon: "bar-chart", _path: "/OrderingStatistics", _component: OrderingStatistics },
	},
	OA管理: {
		_icon: "calculator",
		流程管理: { _icon: "search", _path: "/ProcessManagement", _component: ProcessManagement, },
		印章管理: { _icon: "compress", _path: "/SealManagement", _component: SealManagement, },
		人事表单: {
			_icon: "list-alt",
			人事表单查询: { _icon: "search", _path: "/PersonnelFormQuery", _component: (props) => <PersonnelFormManagement {...props} type={'show'} />, },
			人事表单申请: { _icon: "edit", _path: "/PersonnelFormApplication", _component: (props) => <PersonnelFormManagement {...props} type={'add'} />, },
			人事表单签核: { _icon: "check-circle", _path: "/PersonnelFormApproval", _component: PersonnelFormManagement, },
		},
		IT表单: {
			_icon: "list-alt",
			IT表单查询: { _icon: "search", _path: "/ITFormQuery", _component: (props) => <ITFormManagement {...props} type={'show'} />, },
			IT表单申请: { _icon: "edit", _path: "/ITFormApplication", _component: (props) => <ITFormManagement {...props} type={'add'} />, },
			IT表单签核: { _icon: "check-circle", _path: "/ITFormApproval", _component: ITFormManagement, },
		},
		其他表单: {
			_icon: "list-alt",
			其他表单查询: { _icon: "search", _path: "/OthersFormQuery", _component: (props) => <OthersFormManagement {...props} type={'show'} />, },
			其他表单申请: { _icon: "edit", _path: "/OthersFormApplication", _component: (props) => <OthersFormManagement {...props} type={'add'} />, },
			其他表单签核: { _icon: "check-circle", _path: "/OthersFormApproval", _component: OthersFormManagement, },
		},
		预支单: {
			_icon: "calculator",
			预支申请: { _icon: "edit", _path: "/AdvanceApplication", _component: AdvanceApplication, },
			预支签核: { _icon: "check-circle", _path: "/AdvanceEndorsement", _component: AdvanceEndorsement, },
			金额支付: { _icon: "calculator", _path: "/AdvanceAmountPayment", _component: AdvanceAmountPayment, },
			预支查询: { _icon: "search", _path: "/AdvanceQuery", _component: AdvanceQuery, },
		},
		报支单: {
			_icon: "calculator",
			报支申请: { _icon: "edit", _path: "/ExpenseApplication", _component: ExpenseApplication, },
			报支签核: { _icon: "check-circle", _path: "/ExpenseEndorsement", _component: ExpenseEndorsement, },
			金额支付: { _icon: "calculator", _path: "/ExpenseAmountPayment", _component: ExpenseAmountPayment, },
			报支查询: { _icon: "search", _path: "/ExpenseQuery", _component: ExpenseQuery, },
		},
		请购单: {
			_icon: "calculator",
			请购申请: { _icon: "edit", _path: "/RequisitionApplication", _component: RequisitionApplication, },
			请购签核: { _icon: "check-circle", _path: "/RequisitionEndorsement", _component: RequisitionEndorsement, },
			请购议价: { _icon: "calculator", _path: "/RequisitionBargaining", _component: RequisitionBargaining, },
			请购查询: { _icon: "search", _path: "/RequisitionQuery", _component: RequisitionQuery, },
		},
		采购单: {
			_icon: "calculator",
			待采购物品: { _icon: "cart-plus", _path: "/ItemsToBePurchased", _component: ItemsToBePurchased, },
			采购申请: { _icon: "edit", _path: "/PurchaseApplication", _component: PurchaseApplication, },
			采购签核: { _icon: "check-circle", _path: "/PurchaseEndorsement", _component: PurchaseEndorsement, },
			采购查询: { _icon: "search", _path: "/PurchaseQuery", _component: PurchaseQuery, },
			采购验收: {
				_icon: "calculator",
				待验收: { _icon: "check-circle", _path: "/PurchaseToBeAccepted", _component: PurchaseToBeAccepted, },
				已验收: { _icon: "check-circle", _path: "/PurchaseAccepted", _component: PurchaseAccepted, },
			},
			申请人验收: { _icon: "check-circle", _path: "/ApplicantToBeAccepted", _component: ApplicantToBeAccepted, },
			采购物品查询: { _icon: "check-circle", _path: "/ApplicantAccepted", _component: ApplicantAccepted, },
			// 申请人验收: {
			// 	_icon: "calculator",
			// 	待验收: { _icon: "check-circle", _path: "/ApplicantToBeAccepted", _component: ApplicantToBeAccepted, },
			// 	已验收: { _icon: "check-circle", _path: "/ApplicantAccepted", _component: ApplicantAccepted, },
			// },
			待入库消耗品: { _icon: "truck", _path: "/ConsumablesToBeWarehoused", _component: ConsumablesToBeWarehoused, },
			固定资产验收: {
				_icon: "calculator",
				待验收资产: { _icon: "check-circle", _path: "/AssetsToBeAccepted", _component: AssetsToBeAccepted, },
				资产验收申请: { _icon: "edit", _path: "/AssetAcceptanceApplication", _component: AssetAcceptanceApplication, },
				资产验收签核: { _icon: "check-circle", _path: "/AssetAcceptanceSignature", _component: AssetAcceptanceSignature, },
				设备信息录入: { _icon: "book", _path: "/EquipmentInformationEntry", _component: EquipmentInformationEntry, },
				资产验收查询: { _icon: "search", _path: "/AssetAcceptanceQuery", _component: AssetAcceptanceQuery, },
			}
		},
		固定资产异动: {
			_icon: "calculator",
			异动申请: { _icon: "check-circle", _path: "/AssetChangeApplication", _component: AssetChangeApplication, },
			异动签核: { _icon: "check-circle", _path: "/AssetChangeEndorsement", _component: AssetChangeEndorsement, },
			资产异动: { _icon: "check-circle", _path: "/AssetChange", _component: AssetChange, },
			异动查询: { _icon: "check-circle", _path: "/AssetChangeQuery", _component: AssetChangeQuery, },
		}
	},
	数据查询: {
		_icon: "bars",
		合同查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu85", _component: TyanLims },
		报告查询: { _icon: "search", _path: "/TyanLims/UCQueryReportManagerPage", _component: TyanLims },
		逾期报告查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu138", _component: TyanLims },
		样品查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu124", _component: TyanLims },
		逾期账款查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu149", _component: TyanLims },
	},
	业务管理: {
		_icon: "bars",
		委托申请: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu2", _component: TyanLims },
		业务报价: {
			_icon: "bars",
			委外金额确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu4", _component: TyanLims },
			业务报价: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu9", _component: TyanLims },
			报价初审: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu6", _component: TyanLims },
			报价审核: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu7", _component: TyanLims },
			报价复审: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu8", _component: TyanLims },
		},
		结案发送: { _icon: "paper-plane", _path: "/TyanLims/UCDynamicMenu11", _component: TyanLims },
		结案确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu150", _component: TyanLims },
		满意度调查: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu151", _component: TyanLims },
		合同变更: {
			_icon: "bars",
			合同变更申请: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu66", _component: TyanLims },
			合同变更审批: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu152", _component: TyanLims },
			合同变更修改: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu153", _component: TyanLims },
			合同修改审批: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu154", _component: TyanLims },
			合同变更查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu155", _component: TyanLims },
		},
	},
	客户管理: {
		_icon: "bars",
		客户查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu106", _component: TyanLims },
		联系记录查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu113", _component: TyanLims },
		联系提醒: { _icon: "bell-o", _path: "/TyanLims/UCDynamicMenu13", _component: TyanLims },
		客户管理: { _icon: "users", _path: "/TyanLims/UCCustomerManagerPage", _component: TyanLims },
		邮件管理: { _icon: "envelope", _path: "/TyanLims/UCDynamicMenu102", _component: TyanLims },
		新客户申请: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu111", _component: TyanLims },
		新客户审核: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu109", _component: TyanLims },
		新客户批准: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu110", _component: TyanLims },
		客户信息修改申请: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu130", _component: TyanLims },
		客户信息修改审核: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu131", _component: TyanLims },
		客户信息修改批准: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu132", _component: TyanLims },
		客户信息修改查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu133", _component: TyanLims },
	},
	检测管理: {
		_icon: "bars",
		工程委外确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu5", _component: TyanLims },
		进案前主管确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu3", _component: TyanLims },
		拍照上传: { _icon: "camera", _path: "/TyanLims/UCDynamicMenu10", _component: TyanLims },
		检前处理: { _icon: "hand-lizard-o", _path: "/TyanLims/UCDynamicMenu140", _component: TyanLims },
		品质管制: { _icon: "balance-scale", _path: "/TyanLims/UCDynamicMenu36", _component: TyanLims },
		数据录入: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu141", _component: TyanLims },
		数据审核: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu142", _component: TyanLims },
		检测小组修改: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu128", _component: TyanLims },
		试剂配制: {
			_icon: "bars",
			试剂配制查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu93", _component: TyanLims },
			试剂配制管理: { _icon: "flask", _path: "/TyanLims/UCDynamicMenu90", _component: TyanLims },
			试剂配制复核: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu92", _component: TyanLims },
		},
	},
	报告管理: {
		_icon: "bars",
		报告编制: { _icon: "edit", _path: "/TyanLims/UCReportMakeManagePage", _component: TyanLims },
		报告审核: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu20", _component: TyanLims },
		报告批准: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu22", _component: TyanLims },
		报告制作: { _icon: "print", _path: "/TyanLims/UCDynamicMenu145", _component: TyanLims },
		正式报告: { _icon: "print", _path: "/TyanLims/UCDynamicMenu144", _component: TyanLims },
		报告变更申请: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu86", _component: TyanLims },
		报告变更审批: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu87", _component: TyanLims },
		报告变更核准: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu112", _component: TyanLims },
		报告变更批准: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu88", _component: TyanLims },
		报告变更查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu89", _component: TyanLims },
	},
	样品管理: {
		_icon: "bars",
		待入库: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu116", _component: TyanLims },
		检测领样: { _icon: "shopping-cart", _path: "/TyanLims/UCDynamicMenu117", _component: TyanLims },
		检后还样: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu118", _component: TyanLims },
		仓库中: { _icon: "university", _path: "/TyanLims/UCDynamicMenu119", _component: TyanLims },
		退样申请: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu101", _component: TyanLims },
		退样审批: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu60", _component: TyanLims },
		退样确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu61", _component: TyanLims },
		退样查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu129", _component: TyanLims },
		销毁确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu120", _component: TyanLims },
		待销毁: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu121", _component: TyanLims },
		待退样: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu122", _component: TyanLims },
		已出库: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu123", _component: TyanLims },
	},
	实验室管理: {
		_icon: "bars",
		测试项目: { _icon: "cubes", _path: "/TyanLims/UCDynamicMenu24", _component: TyanLims },
		检测方法: { _icon: "leanpub", _path: "/TyanLims/UCDynamicMenu25", _component: TyanLims },
		原始记录: { _icon: "file-text", _path: "/TyanLims/UCDynamicMenu27", _component: TyanLims },
		项目分类管理: { _icon: "edit", _path: "/TyanLims/UCInspectionKindManagerPage", _component: TyanLims },
		项目取样信息管理: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu32", _component: TyanLims },
		设备管理: { _icon: "cogs", _path: "/TyanLims/UCInstrumentManagerPage", _component: TyanLims },
	},
	采购管理: {
		_icon: "bars",
		供应商管理: {
			_icon: "users",
			供应商管理: { _icon: "users", _path: "/SupplierManagerPage", _component: SupplierManagerPage },
			供应商新增申请: { _icon: "edit", _path: "/NewSupplierApplication", _component: NewSupplierApplication },
			供应商新增签核: { _icon: "check-circle", _path: "/NewSupplierEndorsement", _component: NewSupplierEndorsement },
			供应商新增查询: { _icon: "search", _path: "/SearchNewSupplier", _component: SearchNewSupplier },
			供应商信息修改申请: { _icon: "edit", _path: "/SupplierEditApplication", _component: SupplierEditApplication },
			供应商信息修改签核: { _icon: "check-circle", _path: "/SupplierEditEndorsement", _component: SupplierEditEndorsement },
			供应商信息修改查询: { _icon: "search", _path: "/SearchSupplierEdit", _component: SearchSupplierEdit },
		},

		物料管理: { _icon: "users", _path: "/MaterialManagement", _component: MaterialManagement },
		评价项目: { _icon: "users", _path: "/EvaluateItemManager", _component: EvaluateItemManager },
		评价管理: {
			_icon: "bars",
			评价申请: { _icon: "users", _path: "/EvaluationApplication", _component: EvaluationApplication },
			退回申请: { _icon: "users", _path: "/ReturnApplication", _component: ReturnApplication },
			审核评分: { _icon: "users", _path: "/AuditEvaluation", _component: AuditEvaluation },
			意见填写: { _icon: "users", _path: "/OpinionFilling", _component: OpinionFilling },
			评价查询: { _icon: "users", _path: "/EvaluationQuery", _component: EvaluationQuery },
		},
		采购记录: { _icon: "list-ol", _path: "/TyanLims/UCDynamicMenu37", _component: TyanLims },
		一级分类管理: { _icon: "flask", _path: "/ConsumableCategoryMagement", _component: ConsumableCategoryMagement },
		耗材管理: { _icon: "flask", _path: "/TyanLims/UCConsumableMangerPage", _component: TyanLims },
	},
	收费管理: {
		_icon: "bars",
		委外发票管理: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu38", _component: TyanLims },
		对账管理: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu104", _component: TyanLims },
		开票管理: {
			_icon: "bars",
			开票申请: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu40", _component: TyanLims },
			助理确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu157", _component: TyanLims },
			开票审批: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu100", _component: TyanLims },
			开票登记: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu46", _component: TyanLims },
			发票签收: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu76", _component: TyanLims },
			发票重开退回: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu146", _component: TyanLims },
			发票重开审批: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu147", _component: TyanLims },
			发票重开处理: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu148", _component: TyanLims },
			重开发票查询: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu158", _component: TyanLims },
			开票记录查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu156", _component: TyanLims },
		},
		到账登记: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu67", _component: TyanLims },
		到账分摊: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu68", _component: TyanLims },
		未核销发票: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu70", _component: TyanLims },
		发票查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu103", _component: TyanLims },
		发票: { _icon: "search", _path: "/TyanLims/UCDynamicMenu160", _component: TyanLims },
	},

	项目管理: {
		_icon: "bars",
		方法管理: {
			_icon: "bars",
			方法申请: { _icon: "edit", _path: "/MethodApplication", _component: MethodApplication },
			方法审批: { _icon: "check-circle", _path: "/MethodApprove", _component: MethodApprove },
			方法验证: { _icon: "edit", _path: "/MethodVerification", _component: MethodVerification },
			方法验证确认: { _icon: "check-circle", _path: "/MethodVerificationComfirm", _component: MethodVerificationComfirm },
			主任验证确认: { _icon: "check-circle", _path: "/DirectorVerificationComfirm", _component: DirectorVerificationComfirm },
			方法申请记录查询: { _icon: "search", _path: "/MethodApplyQuery", _component: MethodApplyQuery },
		},
		项目作废管理: {
			_icon: "bars",
			项目作废申请: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu134", _component: TyanLims },
			项目作废审核: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu135", _component: TyanLims },
			项目作废批准: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu136", _component: TyanLims },
			项目作废查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu137", _component: TyanLims },
		},
		'新增/修改项目': {
			_icon: "bars",
			_icon: "bars",
			项目申请: { _icon: "edit", _path: "/JudgeStandardApplication", _component: JudgeStandardApplication },
			金额录入: { _icon: "edit", _path: "/AmountEntry", _component: AmountEntry },
			项目初审: { _icon: "check-circle", _path: "/JudgeStandardPreReview", _component: JudgeStandardPreReview },
			新增修改: { _icon: "edit", _path: "/JudgeStandardNewModify", _component: JudgeStandardNewModify },
			项目审核: { _icon: "check-circle", _path: "/JudgeStandardReview", _component: JudgeStandardReview },
			金额批准: { _icon: "check-circle", _path: "/AmountApprove", _component: AmountApprove },
			申请查询: { _icon: "search", _path: "/JudgeStandardApplyQuery", _component: JudgeStandardApplyQuery },
		},
	},

	品质管理: {
		_icon: "bars",
		// 项目管理: {
		// 	_icon: "bars",
		// 	项目申请: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu39", _component: TyanLims },
		// 	项目审批: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu41", _component: TyanLims },
		// 	项目方法验证: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu42", _component: TyanLims },
		// 	方法验证确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu43", _component: TyanLims },
		// 	主任验证确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu44", _component: TyanLims },
		// 	申请记录查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu45", _component: TyanLims },
		// },
		监督计划管理: {
			_icon: "bars",
			计划制定: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu47", _component: TyanLims },
			计划执行: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu48", _component: TyanLims },
			上传监督记录: { _icon: "upload", _path: "/TyanLims/UCDynamicMenu49", _component: TyanLims },
			日常监督计划查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu51", _component: TyanLims },
		},
		质量管理: {
			_icon: "bars",
			制定计划: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu99", _component: TyanLims },
			执行计划: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu98", _component: TyanLims },
			完成计划: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu54", _component: TyanLims },
			质量计划查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu55", _component: TyanLims },
		},
		培训管理: {
			_icon: "bars",
			培训管理: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu94", _component: TyanLims },
			开展培训: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu95", _component: TyanLims },
			培训结果: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu96", _component: TyanLims },
			培训评估: { _icon: "edit", _path: "/TyanLims/UCDynamicMenu97", _component: TyanLims },
			培训确认: { _icon: "check-circle", _path: "/TyanLims/UCDynamicMenu108", _component: TyanLims },
			培训查询: { _icon: "search", _path: "/TyanLims/UCDynamicMenu143", _component: TyanLims },
		},
	},
	报表管理: {
		_icon: "bars",
		数据统计: { _icon: "bar-chart", _path: "/TyanLims/UCSheetGenManagerPage", _component: TyanLims },
		历史报表查询: { _icon: "search", _path: "/TyanLims/UCSheetManagerPage", _component: TyanLims },
	},
	系统管理: {
		_icon: "cogs",
		系统参数: { _icon: "cog", _path: "/Settings", _component: SysSettings, _ },
		职务管理: { _icon: "cog", _path: "/JobManagement", _component: JobManagement, _ },
		签核职务: { _icon: "cog", _path: "/SignOffPositionManagement", _component: SignOffPositionManagement, _ },
		币别管理: { _icon: "yen", _path: "/CurrencyManagement", _component: CurrencyManagement, _ },
		汇率管理: { _icon: "dollar", _path: "/ExchangeRateManagement", _component: ExchangeRateManagement, _ },
		开户账号管理: { _icon: "users", _path: "/AccountOpenManagement", _component: AccountOpenManagement, _ },
		节假日管理: { _icon: "calendar", _path: "/SysHolidayManagement", _component: SysHolidayManagement, },
		服务配置: { _icon: "server", _path: "/ServiceManagement", _component: ServiceManagement, },
	},

	修改密码: { _icon: "wrench", _path: "/ChangePassword", _component: ChangePassword, _public: true, },
	注销: { _icon: "sign-out", _path: "/Logout", _component: Logout, _public: true, },
}